<template>
  <div class="completeOrder">
    <!-- 关闭原因 -->
    <van-sticky :offset-top="judgeRemarkOffsetTop" v-if="judge_remark">
      <p class="judgeRemark">{{ judge_remark }}</p>
    </van-sticky>
    <!-- d导航栏 -->
    <van-tabs
      v-model="active"
      scrollspy
      sticky
      :offset-top="offsetTop"
      background="#F5F6FF"
      color="#5853E9"
      line-width="24px"
      line-height="4px"
    >
      <van-tab title="基础信息">
        <!-- 1 -->
        <div class="completeOrderOut">
          <First :isOrderEnd="true" :progress="progress" :id="id"></First>
        </div>
      </van-tab>
      <van-tab title="房屋信息">
        <!-- 2 -->
        <div class="completeOrderOut">
          <Second :isOrderEnd="true" :progress="progress" :id="id"></Second>
        </div>
      </van-tab>
      <van-tab title="缴费凭证">
        <!-- 3 -->
        <div class="completeOrderOut">
          <Third :isOrderEnd="true" :progress="progress" :id="id"></Third>
        </div>
      </van-tab>
      <van-tab title="电子合同">
        <!-- 4 -->
        <div class="completeOrderOut">
          <Fourth
            :isOrderEnd="true"
            :progress="progress"
            :id="id"
            :order_sn="order_sn"
            :order_status="order_status"
          ></Fourth>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import First from "./first.vue";
import Second from "./second.vue";
import Third from "./third.vue";
import Fourth from "./fourth.vue";
export default {
  props: {
    id: {
      default: "",
    },
    judge_remark: {
      default: null,
    },
    order_sn: {
      default: "",
    },
    order_status: {
      default: 5,
    },
  },
  data() {
    return {
      isiOSX: false,
      progressBarData: [
        "确认基础信息",
        "填写房屋信息",
        "上传缴费凭证",
        "签署合同",
      ],
      progress: 5, //实际进度
      active: 0,
      offsetTop: "68px",
      judgeRemarkOffsetTop: "68px",
    };
  },
  components: { First, Second, Third, Fourth },
  mounted() {
    this.isiOSX = this.isIphoneX();
    if (this.isiOSX) {
      this.judgeRemarkOffsetTop = "88px";
    } else {
      this.judgeRemarkOffsetTop = "68px";
    }
    if (this.isiOSX && this.judge_remark) {
      this.offsetTop = "128px";
    }
    if (this.isiOSX && !this.judge_remark) {
      this.offsetTop = "88px";
    }
    if (!this.isiOSX && this.judge_remark) {
      this.offsetTop = "108px";
    }
    if (!this.isiOSX && !this.judge_remark) {
      this.offsetTop = "68px";
    }
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    this.getOrderProgress();
  },
  methods: {
    //   获取订单进度
    getOrderProgress() {
      this.$api
        .post("decoration/member/order/flow", {
          order_id: this.id,
        })
        .then((res) => {
          this.progress = res.flow_id;
          //   console.log(res);
        });
    },
  },
};
</script>
<style lang="less" scoped>
.completeOrder {
  .judgeRemark {
    padding: 10px 12px;
    background: #ffdbc6;
    font-size: 14px;
    color: #ff7e31;
    line-height: 20px;
  }
  .completeOrderOut {
    margin: 0 16px;
  }
  ::v-deep .van-tab {
    font-size: 15px;
  }
  ::v-deep .van-tab--active{
    color: #5853e9;
    font-weight: bold;
  }
  ::v-deep .van-tabs__line {
    background: linear-gradient(90deg, #918bf6 0%, #5853e9 100%);
  }
  ::v-deep .van-tabs__wrap{
    padding-bottom: 5px;

  }
}
</style>